import {TranslateService} from '@ngx-translate/core';

export enum FileType {
  Image = 'Image',
  Blog = 'Blog',
  Video = 'Video',
  Audio = 'Audio',
}

export const contentType = (translate: TranslateService) => {
  return [
    {key: FileType.Image, value: translate.instant('imageLbl')},
    {key: FileType.Blog, value: translate.instant('blogLbl')},
    {key: FileType.Video, value: translate.instant('videoLbl')},
    {key: FileType.Audio, value: translate.instant('audioLbl')},
  ];
};
